export const JOB_EMAIL_CATEGORY = "job_email";

export const SETUP_TABS = [
  { id: "job_email", label: "Job Email Configuration" },
];

export const JOB_EMAIL_CONFIGS = [
  {
    key: "acd_monthly_processing_completed",
    title: "ACD Monthly Processing Completed",
    description:
      "Email recipients notified when ACD monthly data import and processing completes successfully.",
    jobCode: "ACD Monthly Processing Completed",
  },
  {
    key: "queues_missing_brand_association",
    title: "Queues Missing Brand Association",
    description:
      "Email recipients notified when imported ACD data contains queues that are not bound to brands.",
    jobCode: "Queues Missing Brand Association",
  },
  {
    key: "generate_full_program_report",
    title: "ACD PDF Report Generated",
    description:
      "Email recipients notified when the full program ACD PDF report is generated.",
    jobCode: "GenerateFullProgramReportJob",
  },
  {
    key: "monthly_invoice_generation_success",
    title: "Monthly Invoice Generation Success",
    description:
      "Email recipients notified when monthly invoice generation completes successfully.",
    jobCode: "Monthly Invoice Generation Success",
  },
  {
    key: "invoice_lifecycle_email",
    title: "Invoice Lifecycle Notifications",
    description:
      "Email recipients notified when an invoice is published, fails to publish, or is unpublished.",
    jobCode: "InvoiceLifecycleEmail",
  },
];

export const emptyRecipientValue = () => ({
  user_ids: [],
  custom_emails: [],
});
